const BetsModule = () => import(/* webpackChunkName: "bets-module" */ './views/Module.vue');
const Bets = () => import(/* webpackChunkName: "bets" */ './views/Bets.vue');
const WinLoss = () => import(/* webpackChunkName: "win-loss" */ './views/WinLoss.vue');
const WinLossDetails = () => import(/* webpackChunkName: "win-loss" */ './views/WinLossDetails.vue');
const Statement = () => import(/* webpackChunkName: "statement" */ './views/Statement.vue');
const CasinoWinLossDetails = () => import(/* webpackChunkName: "casinowinloss" */ './views/CasinoWinLossDetails.vue');
const BetsRoutes = {
    path: '/',
    component: BetsModule,
    children: [
        {
            path: 'bets',
            name: 'bets',
            component: Bets,
        },
        // {
        //     path: 'match-market',
        //     name: 'match-market',
        //     component: MatchMarket,
        // },
        {
            path: 'win-loss',
            name: 'win-loss',
            component: WinLoss,
        },
        {
            path: 'win-loss-details',
            name: 'win-loss-details',
            component: WinLossDetails,
        },
        {
            path: 'bet-history',
            name: 'bet-history',
            component: Bets,
        },
        {
            path: 'account-statement',
            name: 'statement',
            component: Statement,
        },
        {
            path: 'transfer-statement',
            name: 'transfer-statement',
            component: Statement,
        },
        {
            path: 'casino-win-loss-details',
            name: 'casino-win-loss-details',
            component: CasinoWinLossDetails,
        }
    ],
}

export default BetsRoutes;